import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Lozenge from '@atlaskit/lozenge';
import Tabs, { TabList, TabPanel } from '@atlaskit/tabs';
import React, { useEffect, useState } from 'react';
import { HorizontalScrollShadow, StyledLozenge, TabListContainer } from './ResponsiveTabs.styles';
import { Tab } from './Tab';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const TabLozenge = _ref => {
  let {
    appearance,
    label
  } = _ref;
  return /*#__PURE__*/_jsx(StyledLozenge, {
    children: /*#__PURE__*/_jsx(Lozenge, {
      appearance: appearance,
      children: label
    })
  });
};
const getSelectedTabIndex = (selected, tabs) => typeof selected === 'number' ? selected : tabs.findIndex(tab => tab.key === selected);

/**
 * A wrapper over Atlaskit tabs that allows additional tabs to
 * be horizontally scrollable if the screen size is too small.
 *
 */
export default function ResponsiveTabs(props) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(getSelectedTabIndex(props.selected, props.tabs));
  const [isTabChange, setIsTabChange] = useState(false);
  const openTabs = props.tabs;
  useEffect(() => {
    // A11y: this is required when using the keyboard to navigate tab links.
    const currentTabIndex = getSelectedTabIndex(props.selected, props.tabs);
    if (selectedTabIndex !== currentTabIndex) {
      setSelectedTabIndex(currentTabIndex);
      setIsTabChange(true);
    }
  }, [props.selected, props.tabs]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props === null || props === void 0 ? void 0 : props.afterTabs, /*#__PURE__*/_jsx(HorizontalScrollShadow, {}), /*#__PURE__*/_jsxs(Tabs, {
      id: props.id,
      testId: props.testId,
      selected: selectedTabIndex,
      onChange: tabIndex => props.onChange(props.tabs[tabIndex].key),
      children: [/*#__PURE__*/_jsx(TabListContainer, {
        children: /*#__PURE__*/_jsx(TabList, {
          children: openTabs.map((tab, index) => /*#__PURE__*/_jsxs(Tab, {
            testId: tab.testId,
            isSelected: isTabChange && selectedTabIndex === index,
            children: [tab.label, !!tab.lozenge && /*#__PURE__*/_jsx(TabLozenge, _objectSpread({}, tab.lozenge))]
          }, tab.key))
        })
      }), props.tabs.map(tab => /*#__PURE__*/_jsx(TabPanel, {
        children: tab.content
      }, tab.key))]
    })]
  });
}